export const Footer = () => {
    return (
        <footer className="flex justify-center mt-5 text-xs text-gray-600 font-normal dark:text-gray-400 p-2">
            Made with &nbsp;
            <span
                className="text-red-600 text-xl"
                style={{ marginTop: "-.5%" }}
            >
                &#9829;
            </span>
            &nbsp; by &nbsp;
            <a className="text-sky-600" href="https://evanswanjau.netlify.app">
                Evans Wanjau
            </a>
        </footer>
    );
}